import { _ as _array_like_to_array } from "./_array_like_to_array.js";

function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
export { _array_without_holes as _ };
